"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Archer = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListSubheader = _interopRequireDefault(require("@material-ui/core/ListSubheader"));

var _ListItemWrapper = _interopRequireDefault(require("../ListItemWrapper"));

var _useStyles = _interopRequireDefault(require("../useStyles"));

var _Hocs = require("../../Hocs");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Archer = function Archer(_ref) {
  var subheader = _ref.subheader,
      subheaderComponent = _ref.subheaderComponent,
      underline = _ref.underline,
      lists = _ref.lists;
  var classes = (0, _useStyles["default"])({
    underline: underline
  });

  var HeadingLevel = function HeadingLevel(props) {
    return /*#__PURE__*/_react["default"].createElement(subheaderComponent, props);
  };

  return /*#__PURE__*/_react["default"].createElement(_List["default"], {
    className: classes.root,
    subheader: subheader ? /*#__PURE__*/_react["default"].createElement(_ListSubheader["default"], {
      color: "inherit",
      className: classes.root,
      component: "li",
      disableSticky: true
    }, /*#__PURE__*/_react["default"].createElement(HeadingLevel, {
      className: classes.heading
    }, subheader)) : null
  }, /*#__PURE__*/_react["default"].createElement(_ListItemWrapper["default"], {
    lists: lists,
    underline: underline
  }));
};

exports.Archer = Archer;
Archer.defaultProps = {
  underline: false,
  subheader: '',
  lists: [],
  subheaderComponent: 'h3'
};
Archer.propTypes = {
  underline: _propTypes["default"].bool,
  subheader: _propTypes["default"].string,
  // eslint-disable-next-line react/forbid-prop-types
  lists: _propTypes["default"].array,
  subheaderComponent: _propTypes["default"].string
};

var _default = (0, _Hocs.renderListSafely)(Archer);

exports["default"] = _default;